import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Bell, Search, LogOut, User as UserIcon, Menu } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { Badge } from './ui/badge';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from './ui/dropdown-menu';
import { SidebarContext } from './AppSidebar';

export function Topbar({ user, onLogout }) {
  const history = useHistory();
  const { collapsed, setCollapsed } = useContext(SidebarContext);

  const displayUser = user || { name: 'User', email: '', role: 'user', initials: 'U' };
  const initials = displayUser.initials || (displayUser.name ? displayUser.name.charAt(0).toUpperCase() : 'U');

  const handleLogout = () => {
    if (onLogout) onLogout();
    // Note: performLogout already pushes to /login; no need to push again here.
  };

  return (
    <header className="ih-topbar">
      <button
        onClick={() => setCollapsed(!collapsed)}
        aria-label="Toggle sidebar"
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted-foreground)', padding: 4, borderRadius: 4, display: 'flex', alignItems: 'center' }}
      >
        <Menu style={{ width: 18, height: 18 }} />
      </button>

      <div className="hidden md:flex items-center gap-2 ml-2">
        <span style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.2em', color: 'var(--muted-foreground)' }}>
          IMAGE-I
        </span>
        <span style={{ fontSize: 11, color: 'rgba(107,122,116,0.4)' }}>/</span>
        <span style={{ fontSize: 11, color: 'var(--foreground)', opacity: 0.8 }}>Management Reporting</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        {/* Search */}
        <div className="relative hidden md:block">
          <Search style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', width: 14, height: 14, color: 'var(--muted-foreground)' }} />
          <input
            placeholder="Search reports, KPIs, dashboards…"
            style={{
              height: 36, width: 280, paddingLeft: 32, paddingRight: 12,
              background: 'var(--muted)', border: '1px solid var(--border)',
              borderRadius: 8, fontSize: 13, color: 'var(--foreground)',
              outline: 'none',
            }}
          />
        </div>

        <ThemeToggle />

        {/* Notifications */}
        <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted-foreground)', padding: 6, borderRadius: 6, display: 'flex', alignItems: 'center' }}>
          <Bell style={{ width: 16, height: 16 }} />
        </button>

        {/* User menu */}
        <DropdownMenu>
          <DropdownMenuTrigger>
            <button
              style={{
                width: 36, height: 36, borderRadius: '50%',
                background: 'var(--gradient-primary)',
                display: 'grid', placeItems: 'center',
                fontSize: 12, fontWeight: 600, color: '#fff',
                border: 'none', cursor: 'pointer',
              }}
            >
              {initials}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" style={{ minWidth: 220, zIndex: 100 }}>
            <DropdownMenuLabel>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <span style={{ fontSize: 13, fontWeight: 500 }}>{displayUser.name}</span>
                <span style={{ fontSize: 11, color: 'var(--muted-foreground)' }}>{displayUser.email}</span>
                <Badge variant="outline" style={{ marginTop: 4, width: 'fit-content', fontSize: 10, textTransform: 'capitalize' }}>
                  {displayUser.role}
                </Badge>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => history.push('/imagei/profile')}>
              <UserIcon style={{ width: 14, height: 14, marginRight: 8 }} /> My profile
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => history.push('/imagei/settings')}>
              <UserIcon style={{ width: 14, height: 14, marginRight: 8 }} /> Workspace settings
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} style={{ color: 'var(--destructive)' }}>
              <LogOut style={{ width: 14, height: 14, marginRight: 8 }} /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
